import { render, staticRenderFns } from "./AdminChats.vue?vue&type=template&id=cb5743c6&scoped=true&"
import script from "./AdminChats.vue?vue&type=script&lang=js&"
export * from "./AdminChats.vue?vue&type=script&lang=js&"
import style0 from "./AdminChats.vue?vue&type=style&index=0&id=cb5743c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5743c6",
  null
  
)

export default component.exports